<template>
    <div class="addressbox">
        <div class="address">
            <div class="address-icon"></div>
            <div class="address-right">
                <div>
                    <span class="address-name">{{ addressData && addressData.consigneeName }}</span>
                    <span class="address-phone">{{
                        addressData && addressData.consigneePhone
                    }}</span>
                </div>
                <div class="address-detail">
                    {{ addressData && addressData.consigneeAddress }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'order-address-box',
    props: ['addressData'],
    data() {
        return {}
    }
}
</script>

<style lang="less" scoped>
.addressbox {
    // margin-top: 8px;
    .address {
        padding: 12px;
        background: #fff;
        display: flex;
        align-items: center;
        .address-icon {
            width: 30px;
            height: 30px;
            background: url('https://fr-static.shopshops.top/20200328/address.5bb3cce63e4b12ac.png')
                no-repeat;
            background-size: 100% 100%;
            margin-right: 10px;
        }
        .address-right {
            flex: 1;
            text-align: left;
            .address-name {
                font-size: 16px;
                color: #161a1a;
                font-weight: bold;
                letter-spacing: 0;
                margin-right: 8px;
            }
            .address-phone {
                font-size: 13px;
                color: #5a5a5a;
                font-family: "TradeGothicLT";
            }
            .address-detail {
                font-size: 13px;
                color: #5a5a5a;
                margin-top: 5px;
                line-height: 16px;
                font-family: "TradeGothicLT";
            }
        }
    }
}
</style>
